<div id="icons" class="page-layout simple tabbed" fxLayout="column">
    <!-- CONTENT -->
    <div class="content p-24">
        <div>
            <div fxLayout="column">
                <div fxLayout="row wrap">

                    <a routerLink="/cms/menus">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">menu</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Menus'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/cms/pages">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">pageview</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Pages'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/cms/galleries">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">image</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Galleries'|translate}}
                            </div>
                        </div>
                    </a>

                    <a routerLink="/cms/languages">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">language</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Languages'|translate}}
                            </div>
                        </div>
                    </a>

                </div>
            </div>
        </div>
    </div>
</div>
